import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface LoaderState {
  loader: boolean;
}
const initialLoaderState: LoaderState = {
  loader: false,
};
export const loaderSlice = createSlice({
  name: "loader",
  initialState: initialLoaderState,
  reducers: {
    setLoader: (state: any, action: PayloadAction<boolean>) => {
      state.loader = action.payload;
    },
  },
});
export const { setLoader } = loaderSlice.actions;
export default loaderSlice.reducer;
